import {Testimonial} from '@primer/react-brand'
import type {Document} from '@contentful/rich-text-types'
import {logoToDataUrl} from '../FlexSuiteLogos/Logo'
import {renderWithoutParagraphs} from '../../utils'

export type FlexSuiteTestimonialQuoteProps = {
  quote?: Document
  name?: string
  title?: string
  link?: {href: string; text: string}
  logo?: string
}

export function FlexSuiteTestimonialQuote({quote, name, title, link, logo}: FlexSuiteTestimonialQuoteProps) {
  if (!quote) return null

  const logoSrc = logo ? logoToDataUrl(logo) : null

  return (
    <Testimonial variant="expressive" size="large">
      <Testimonial.Quote>{renderWithoutParagraphs(quote)}</Testimonial.Quote>
      {link && <Testimonial.Link href={link.href}>{link.text}</Testimonial.Link>}
      {logoSrc && (
        <Testimonial.Logo>
          <img src={logoSrc} alt={logo} width={60} />
        </Testimonial.Logo>
      )}
      {name && <Testimonial.Name position={title}>{name}</Testimonial.Name>}
    </Testimonial>
  )
}
